import { IDotXetHocVuActionTypes } from "../../action-types/xet-hoc-vu/IDotXetHocVuActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDotXetHocVuReducer } from "../../reducer-model/xet-hoc-vu/IDotXetHocVuReducer";

const iniState: IDotXetHocVuReducer = {
    status: eReducerStatusBase.is_not_initialization,
    dotXetHocVus: [],
};


export const dotXetHocVuReducer = (state: IDotXetHocVuReducer  = iniState, action: IDotXetHocVuActionTypes): IDotXetHocVuReducer => {
    switch (action.type) {
        case "DOT_XET_HOC_VU_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DOT_XET_HOC_VU_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                dotXetHocVus: action.payload
            };
        case "DOT_XET_HOC_VU_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DOT_XET_HOC_VU_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                dotXetHocVuEdit: action.payload
            };
        case "DOT_XET_HOC_VU_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "DOT_XET_HOC_VU_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DOT_XET_HOC_VU_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false
            };
        case "DOT_XET_HOC_VU_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_HOC_VU_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "DOT_XET_HOC_VU_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOT_XET_HOC_VU_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DOT_XET_HOC_VU_UPDATE_TRANG_THAI_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DOT_XET_HOC_VU_UPDATE_TRANG_THAI_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOT_XET_HOC_VU_UPDATE_TRANG_THAI_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}